import * as React from 'react';
import { TabContainer } from '@components/moleculs/tabs/tab/styles';
import type { TabProps } from '@mui/material/Tab';
import MuiTab from '@mui/material/Tab';
import { styled } from 'styled-components';

const Molecule: React.FC<TabProps> = ({ className, onClick, ...rest }) => (
    <TabContainer className={className} onClick={onClick}>
        <MuiTab {...rest} />
    </TabContainer>
);

export const Tab = styled(Molecule)({});
